module.exports = __webpack_public_path__ + "static/img/walsh-james.4a6a1cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/walsh-james.jpg
// module id = F78w
// module chunks = 0